/*
 * @Author: Haotian Zheng
 * @Date: 2023-07-17 09:45:53
 * @Descripttion:
 * @LastEditors: Haotian Zheng
 * @LastEditTime: 2023-08-04 17:01:18
 */
import { reactive } from 'vue'
export const store = reactive({
  name: '',
  headPortraitUrl: '',
  tenantName: '',
  messageSwitch: 0,
})
